import { AcademicCapIcon, BanknotesIcon, HeartIcon, MapPinIcon, PhoneIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import type { DataUpdateGroupId } from '../../../shared/dpRequests';

export const DATA_UPDATE_GROUP_ICONS: Record<DataUpdateGroupId, typeof MapPinIcon> = {
    address: MapPinIcon,
    contact: PhoneIcon,
    maritalStatus: HeartIcon,
    children: UserGroupIcon,
    bankAccount: BanknotesIcon,
    education: AcademicCapIcon,
};

export const MARITAL_STATUS_OPTIONS = [
    { value: 'Solteiro(a)', label: 'Solteiro(a)' },
    { value: 'Casado(a)', label: 'Casado(a)' },
    { value: 'Divorciado(a)', label: 'Divorciado(a)' },
    { value: 'Viúvo(a)', label: 'Viúvo(a)' },
    { value: 'União Estável', label: 'União estável' },
];

export const EDUCATION_TYPE_OPTIONS = [
    { value: 'Ensino Médio', label: 'Ensino médio' },
    { value: 'Graduação', label: 'Graduação' },
    { value: 'Pós-graduação', label: 'Pós-graduação' },
    { value: 'Mestrado', label: 'Mestrado' },
    { value: 'Doutorado', label: 'Doutorado' },
];

export const DATA_UPDATE_INTRO =
    'Escolha o que quer atualizar. Só os itens marcados entram no pedido, e o DP revisa antes de aplicar no seu cadastro.';
